import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export const props = {
  money: {
    title: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__money__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__money__description),
  },
  freedom: {
    title: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__freedom__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__freedom__description),
  },
  hours: {
    title: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__hours__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__hours__description),
  },
  easy: {
    title: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__easy__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__easy__description),
  },
  speed: {
    title: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__speed__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__speed__description),
  },
  transparency: {
    title: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__transparency__title),
    description: () =>
      i18n.t(i18nKeys.dasherApplyPage__valueProps__transparency__description),
  },
}

export default {
  mainTitle: () => i18n.t(i18nKeys.dasherApplyPage__valueProps__mainTitle),
}
